import { MaintenanceTypes } from "./maintenanceTypes";

export const maintenanceReducer = {
  resetIsMaintenance: (state: MaintenanceTypes) => {
    state.isMaintenance = 0;
  },
  resetMaintenanceError: (state: MaintenanceTypes) => {
    state.error = null;
  },
  resetMaintenanceSuccess: (state: MaintenanceTypes) => {
    state.success = null;
  },
  resetMaintenanceMessage: (state: MaintenanceTypes) => {
    state.message = null;
  },
  resetStatusCode: (state: MaintenanceTypes) => {
    state.statusCode = null;
  },
};
